// native pagination styles
.ux-slider-pagination {
    position: absolute;
    text-align: center;
    transition: 300ms opacity;
    transform: translate3d(0, 0, 0);
    z-index: 10;
}

.ux-slider-pagination.swiper-pagination-hidden {
    opacity: 0;
}

/* Common Styles */
.swiper-pagination-fraction,
.swiper-pagination-custom,
.ux-slider-container-horizontal > .swiper-pagination-bullets {
    bottom: 10px;
    left: 0;
    width: 100%;
}

/* Bullets */
.swiper-pagination-bullets-dynamic {
    overflow: hidden;
    font-size: 0;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    transform: scale(0.33);
    position: relative;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
    transform: scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
    transform: scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
    transform: scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
    transform: scale(0.33);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
    transform: scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
    transform: scale(0.33);
}

.ux-slider-pagination .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 50%;
    background: #000;
    opacity: 0.2;
    vertical-align: middle;
}

//button..swiper-pagination-bullet
.ux-slider-pagination .swiper-pagination-bullet {
    border: 0;
    margin: 0;
    padding: 0;
    box-shadow: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

.ux-slider-pagination.swiper-pagination-clickable .swiper-pagination-bullet {
    cursor: pointer;
}

.ux-slider-pagination .swiper-pagination-bullet-active {
    opacity: 1;
    background: var(--swiper-pagination-color, var(--swiper-theme-color));
}

.ux-slider-container-vertical
    > .ux-slider-pagination.swiper-pagination-bullets {
    right: 10px;
    top: 50%;
    transform: translate3d(0, -50%, 0);
}

.ux-slider-container-vertical
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 6px 0;
    display: block;
}

.ux-slider-container-vertical
    > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
}

.ux-slider-container-vertical
    > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet {
    display: inline-block;
    transition: 200ms transform, 200ms top;
}

.ux-slider-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0 4px;
}

.ux-slider-container-horizontal
    > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
}

.ux-slider-container-horizontal
    > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet {
    transition: 200ms transform, 200ms left;
}

.ux-slider-container-horizontal.ux-slider-container-rtl
    > .swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet {
    transition: 200ms transform, 200ms right;
}
/* Progress */
.swiper-pagination-progressbar {
    background: rgba(0, 0, 0, 0.25);
    position: absolute;
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background: var(--swiper-pagination-color, var(--swiper-theme-color));
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transform: scale(0);
    transform-origin: left top;
}

.ux-slider-container-rtl
    .swiper-pagination-progressbar
    .swiper-pagination-progressbar-fill {
    transform-origin: right top;
}

.ux-slider-container-horizontal > .swiper-pagination-progressbar,
.ux-slider-container-vertical
    > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
    width: 100%;
    height: 4px;
    left: 0;
    top: 0;
}

.ux-slider-container-vertical > .swiper-pagination-progressbar,
.ux-slider-container-horizontal
    > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
    width: 4px;
    height: 100%;
    left: 0;
    top: 0;
}

.swiper-pagination-white {
    --swiper-pagination-color: #fff;
}

.swiper-pagination-black {
    --swiper-pagination-color: #000;
}

.swiper-pagination-lock {
    display: none;
}

// custom pagination styles
.ux-slider .ux-slider-pagination {
    display: flex;
    width: auto;
    height: auto;
    align-items: center;
    z-index: $z-index-slider-pagination;

    &__container {
        position: relative;
    }

    &__container--dynamic {
        width: 146px;
        height: 25px;
        overflow: hidden;
    }

    &__navigation-arrow {
        height: auto;
        cursor: pointer;
        padding-left: 5px;
    }

    &__navigation-arrow--prev {
        transform: rotate(180deg);
        padding-left: 5px;
    }

    .swiper-pagination-bullet {
        border-radius: 0;
        margin: 0 4px;
        cursor: pointer;

        &-active {
            vertical-align: middle;
            transform: scale(1.5);
            background: $color-green;
            cursor: default;
        }

        &:focus {
            outline: none;
        }
    }

    &--bottom {
        position: relative;
        width: 100%;
        display: flex;
        justify-content: center;
        padding-top: 20px;
    }

    &--anchor {
        position: absolute;
        transform: translateX(-50%);
    }

    .swiper-pagination-bullet {
        transition: all 0.35s !important;
    }
}

// needed the + 1 specificity
.ux-slider .ux-slider-pagination .ux-slider-pagination__bullet {
    will-change: width margin translate;

    &--invisible {
        background: transparent;
        margin: 0;
        padding: 0;
        width: 0;
        height: 0;
        backface-visibility: hidden;
    }

    &--small {
        transform: scale(0.85);
        transform-origin: center;
        backface-visibility: hidden;
    }

    &--extra-small {
        //messes up spacing if we scale the last one.
        width: 4px;
        height: 4px;
        transform-origin: center;
        backface-visibility: hidden;
    }
}

.ux-slider-inline-pagination-anchor {
    display: block;
    height: $dim-anchor-pagination-vertical;
    width: 100%;
    margin-top: $anchor-pagination-margin-vertical;
    margin-bottom: 5px;
}
